export default "__VITE_ASSET__CIXqbZ3Q__"